module.exports = __webpack_public_path__ + "static/27-faye-1ce46e99ae59e732acf91680f8573656.jpg";